import type { Brand } from "@src/__generated__/urql-graphql";
import { LinkTitle, type LinkTitleProps } from "@src/components/ui-kit";

interface BrandLinkTitleProps
  extends Omit<LinkTitleProps, "href" | "children"> {
  brand: Pick<Brand, "id" | "name">;
}

const BrandLinkTitle = ({ brand, ...props }: BrandLinkTitleProps) => (
  <LinkTitle
    {...props}
    href={{ pathname: "/brands/detail", query: { id: brand.id } }}
  >
    {brand.name}
  </LinkTitle>
);

export default BrandLinkTitle;
